const ELLIPSIS_CHAR = '…';
const ELLIPSIS_LENGTH = 3;
const isContainerOverflowed = (container) => container.scrollHeight > container.clientHeight;
const addEllipsis = (lastNode, container) => {
  lastNode.textContent = `${lastNode.textContent.trimEnd()}${ELLIPSIS_CHAR}`;
  if (isContainerOverflowed(container)) {
    const sliceFromEnd = 2 * ELLIPSIS_LENGTH;
    lastNode.textContent = `${lastNode.textContent.slice(0, -sliceFromEnd)}${ELLIPSIS_CHAR}`;
  }
};
function getRangeLastNode(childNodes, containerBottom) {
  for (let i = childNodes.length - 1; i >= 0; i -= 1) {
    const child = childNodes[i];
    const range = document.createRange();
    range.selectNodeContents(child);
    const rangeRect = range.getBoundingClientRect();
    if (rangeRect.width && rangeRect.height) {
      const lastNodeHeight = containerBottom - Math.round(rangeRect.top);
      if (lastNodeHeight > 0) {
        const fontSize = child.nodeType === Node.TEXT_NODE
          ? parseFloat(getComputedStyle(child.parentNode).fontSize)
          : parseFloat(getComputedStyle(child).fontSize);
        if (lastNodeHeight < fontSize) {
          continue;
        }
        if (child.childNodes.length) {
          return getRangeLastNode(child.childNodes, containerBottom);
        }
        return range;
      }
    }
  }
}
function getStartOffset(range, containerBottom) {
  const elem = range.startContainer;
  for (let offset = range.endOffset; offset > 0; offset -= 1) {
    range.setEnd(elem, offset);
    if (Math.round(range.getBoundingClientRect().bottom) <= containerBottom) {
      return offset;
    }
  }
}
function getTextNodes(node) {
  const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
  const nodes = [];
  while (walker.nextNode()) {
    nodes.push(walker.currentNode);
  }
  return nodes;
}
function getLastTextNodeInLengthWithOffset(textNodes, length) {
  let lastTextNode = null;
  let endOffset = 0;
  for (let i = 0; i < textNodes.length; i++) {
    lastTextNode = textNodes[i];
    endOffset += lastTextNode.textContent.length;
    if (endOffset > length) {
      break;
    }
  }
  return { lastTextNode, endOffset };
}
function trimOverflowedContent(commonContainer, node, offset) {
  const rangeToDelete = document.createRange();
  rangeToDelete.selectNodeContents(commonContainer);
  rangeToDelete.setStart(node, offset);
  rangeToDelete.deleteContents();
  rangeToDelete.detach();
}
export const applyEllipsisByMaxHeight = (container, content) => {
  if (!container) {
    return;
  }
  container.innerHTML = content;
  const containerRect = container.getBoundingClientRect();
  const containerBottom = Math.round(containerRect.bottom);
  if (isContainerOverflowed(container)) {
    const lastNodeInRange = getRangeLastNode(container.childNodes, containerBottom);
    if (lastNodeInRange) {
      const lastNode = lastNodeInRange.startContainer;
      const startOffset = getStartOffset(lastNodeInRange, containerBottom);
      lastNodeInRange.detach();
      trimOverflowedContent(container, lastNode, startOffset);
      addEllipsis(lastNode, container);
    }
  }
};
export const getTrimmedContentByLength = (content, maxLength) => {
  if (!maxLength) {
    return content;
  }
  const container = document.createElement('div');
  container.innerHTML = content;
  if (container.textContent.length <= maxLength) {
    return content;
  }
  const textNodes = getTextNodes(container);
  const { lastTextNode, endOffset } = getLastTextNodeInLengthWithOffset(textNodes, maxLength);
  const overflowedLength = endOffset - maxLength;
  if (overflowedLength <= 0) {
    return content;
  }
  const startOffsetToDelete = lastTextNode.textContent.length - overflowedLength;
  trimOverflowedContent(container, lastTextNode, startOffsetToDelete);
  addEllipsis(lastTextNode, container);
  return container.innerHTML;
};
